import React from 'react';
import { InPostPoint } from '../../models/InPostPoint';
import { motion } from 'framer-motion';

interface InPostPointDetailsProps {
  point: InPostPoint;
}

const InPostPointDetails: React.FC<InPostPointDetailsProps> = ({ point }) => {
  if (!point) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="mt-4 bg-white border border-gray-200 rounded-lg p-4 shadow-sm"
    >
      <div className="flex items-start">
        {point.image_url && (
          <div className="w-24 h-24 flex-shrink-0 mr-4 overflow-hidden rounded-md">
            <img
              src={point.image_url}
              alt={`Paczkomat ${point.name}`}
              className="w-full h-full object-cover"
            />
          </div>
        )}

        <div className="flex-grow">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start">
            <div>
              <h3 className="text-lg font-semibold text-gray-800">
                Paczkomat {point.name}
              </h3>

              <p className="text-sm text-gray-600 mt-1">
                {point.address.line1}, {point.address.line2}
              </p>
            </div>

            <div className="mt-2 sm:mt-0 sm:ml-4">
              <span
                className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium 
                ${point.location_247 ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'}`}
              >
                {point.opening_hours ||
                  (point.location_247 ? '24/7' : 'Standardowe godziny')}
              </span>

              {point.easy_access_zone && (
                <span className="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium bg-amber-100 text-amber-800 ml-1">
                  Strefa łatwego dostępu
                </span>
              )}
            </div>
          </div>

          <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
            <div>
              <span className="text-gray-500">Lokalizacja:</span>
              <p className="text-gray-800">
                {point.location_description || 'Brak szczegółowego opisu'}
              </p>
            </div>

            <div>
              <span className="text-gray-500">Płatności:</span>
              <p className="text-gray-800">
                {point.payment_available
                  ? point.payment_point_descr
                  : 'Płatność niedostępna'}
              </p>
            </div>
          </div>

          {point.physical_type_description && (
            <div className="mt-2 text-xs text-gray-500">
              {point.physical_type_description}
            </div>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default InPostPointDetails;
